import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

function PrivateRoutes() {
  const token     = localStorage.getItem("userInfo");
  const guest     = useSelector((state) => state.guest);
  const isGuest   = guest?.isGuest === true;
  const location  = useLocation();

  return token || isGuest ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
}

export default PrivateRoutes;